module.exports = __webpack_public_path__ + "media/images/Client-default-9b0638eafa8942808263c2812deb89a9.png";